class KlCartOffer extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-kl-complementary-select]');
    this.variantInput = this.querySelector('[data-kl-complementary-variant]');
    this.addButton = this.querySelector('[data-kl-complementary-add]');
    this.select?.addEventListener('change', this.handleChange);
    this.handleChange();
  }

  disconnectedCallback() {
    this.select?.removeEventListener('change', this.handleChange);
  }

  handleChange = () => {
    if (!(this.select instanceof HTMLSelectElement) || !(this.variantInput instanceof HTMLInputElement)) return;

    const option = this.select.selectedOptions[0];
    if (!option) return;

    this.variantInput.value = option.value;
    if (this.addButton instanceof HTMLButtonElement) {
      this.addButton.disabled = option.dataset.available !== 'true';
    }
  };
}

if (!customElements.get('kl-cart-offer')) {
  customElements.define('kl-cart-offer', KlCartOffer);
}
